module.exports = __webpack_public_path__ + "img/text-lowercase.13f4440c.svg";